"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _UnfoldMoreOutlined = _interopRequireDefault(require("@material-ui/icons/UnfoldMoreOutlined"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var MuiSelect = {
  IconComponent: _UnfoldMoreOutlined["default"],
  MenuProps: {
    PaperProps: {
      elevation: 0,
      variant: 'outlined'
    }
  }
};
var _default = MuiSelect;
exports["default"] = _default;